import { render, staticRenderFns } from "./userLabel.vue?vue&type=template&id=8fa5b790&scoped=true&"
import script from "./userLabel.vue?vue&type=script&lang=js&"
export * from "./userLabel.vue?vue&type=script&lang=js&"
import style0 from "./userLabel.vue?vue&type=style&index=0&id=8fa5b790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa5b790",
  null
  
)

export default component.exports